"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNav = exports.SubNavRight = exports.SubNavMenuLabel = exports.SubNavMenus = exports.SubNavCTA = exports.SubNavBreadcrumb = exports.SubNavDivider = void 0;

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

var NavContainer = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f7"
} : {
  target: "e4soo8f7",
  label: "NavContainer"
})(_styles.pageMargins, " display:flex;align-items:center;");
var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f6"
} : {
  target: "e4soo8f6",
  label: "Wrapper"
})("box-shadow:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.tr10;
}, " 0 -1px 0px 0px inset;");
var SubNavDivider = (0, _theming.styled)("hr", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f5"
} : {
  target: "e4soo8f5",
  label: "SubNavDivider"
})("border:none;background-color:", function (props) {
  return props.inverse ? 'rgba(255, 255, 255, 0.1)' : _styles.color.tr10;
}, ";width:1px;height:24px;margin-top:8px;margin-bottom:8px;margin-left:20px;margin-right:20px;@media (min-width: ", _styles.breakpoints[2], "px){margin-left:15px;margin-right:15px;}");
exports.SubNavDivider = SubNavDivider;
var SubNavBreadcrumb = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Link, process.env.NODE_ENV === "production" ? {
  target: "e4soo8f4"
} : {
  target: "e4soo8f4",
  label: "SubNavBreadcrumb"
})(_styles.text.regularBold, ";margin-top:10px;margin-bottom:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
exports.SubNavBreadcrumb = SubNavBreadcrumb;
SubNavBreadcrumb.defaultProps = {
  tertiary: true
};
var SubNavCTA = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Link, process.env.NODE_ENV === "production" ? {
  target: "e4soo8f3"
} : {
  target: "e4soo8f3",
  label: "SubNavCTA"
})(_styles.text.regularBold, ";margin-top:10px;margin-bottom:10px;");
exports.SubNavCTA = SubNavCTA;
var SubNavMenus = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f2"
} : {
  target: "e4soo8f2",
  label: "SubNavMenus"
})("flex:none;display:flex;align-items:center;&>button{margin-right:12px;}&>button:last-child{margin-right:0;}@media (min-width: ", _styles.breakpoints[1], "px){&>button:last-child{margin-right:12px;}}");
exports.SubNavMenus = SubNavMenus;
var SubNavMenuLabel = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f1"
} : {
  target: "e4soo8f1",
  label: "SubNavMenuLabel"
})("font-size:", _styles.typography.size.s2, "px;line-height:20px;color:", _styles.color.dark, ";display:none;@media (min-width: ", _styles.breakpoints[2], "px){display:block;}");
exports.SubNavMenuLabel = SubNavMenuLabel;
var SubNavRight = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e4soo8f0"
} : {
  target: "e4soo8f0",
  label: "SubNavRight"
})("flex:none;display:none;margin-left:auto;@media (min-width: ", _styles.breakpoints[1], "px){display:block;}");
exports.SubNavRight = SubNavRight;

var SubNav = function SubNav(_ref) {
  var children = _ref.children,
      inverse = _ref.inverse;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(NavContainer, null, children));
};

exports.SubNav = SubNav;